import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NavigationExtras, Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';

import { MultiplePropertyListingDto, PropertyListingDto, TaskListDto } from '../../../../../../app/services/property-matrixV2/models';
import { ConfigUserPermissionService } from '../../../../../services/property-matrixV2/custom-services/userPermission.service';
import { PropertyListingService, UserManagementService } from '../../../../../../app/services/property-matrixV2/services';
import { NotificationService } from '../../../../../../app/shared/services/notification-service/notification.service';
import { UserDto } from '../../../../../../app/services/property-matrixV2/models';

@Component({
  selector: 'app-listing-tasks',
  templateUrl: './listing-tasks.component.html',
  styleUrls: ['./listing-tasks.component.scss']
})
export class ListingTasksComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Input() selectedListing: PropertyListingDto;
  @Input() selectedListingGroup: MultiplePropertyListingDto;
  @Input() listingType: string;

  phase: number = 1;
  receivedDate: string | null | undefined;
  taskList: TaskListDto[] = [];
  activeUsers: UserDto[] = [];
  users = [];
  tasks = [];
  displayedColumns: string[] = ['number', 'task', 'user', 'notes', 'status'];
  dataSource = new MatTableDataSource(this.tasks);
  currentUser: UserDto;

  requiredRolesFull: string[] = [];
  requiredRolesView: string[] = [];
  currentUserRoles: string[] | null | undefined = [];

  constructor(
    private router: Router,
    private listingService: PropertyListingService,
    private userService: UserManagementService,
    private notificationService: NotificationService,
    private _userPermissionService: ConfigUserPermissionService,
  ) {
    this.setPhase();
  }

  ngOnInit(): void {
    this.dataSource.sort = this.sort;
    this.receivedDate = (this.listingType === 'single') ? this.selectedListing.createdDate : this.selectedListingGroup.createdDate;
    this.getUsers();
    this.getCurrentUser();
    this.getUserPermissionList();
  }

  setPhase(): void {
    this.tasks = this.tasks.map(task => {
      const user = this.users.find(u => u.name === task.user);
      return {
        ...task,
        role: user.role,
        roleInitial: user.roleInitial,
        roleColor: user.roleColor
      };
    });

    this.dataSource = new MatTableDataSource(this.tasks);
  }

  getPropertyListingTasks(): void {
    this.listingService.apiV1PropertyListingGetTaskListsGet({ propertyListingId: this.selectedListing.id }).pipe().subscribe(result => {
      if (result.length === 0) {
        this.listingService.apiV1PropertyListingCreateAllTaskForPropertyListingGet({ propertyListingId: this.selectedListing.id }).subscribe(res => {
          this.taskList = res;
          this.taskList = this.taskList.sort((a, b) => {
            const numA = a.taskNumber?.number ?? 9999;
            const numB = b.taskNumber?.number ?? 9999;
            return numA - numB;
          });
          let newUsers = [];
          let newTasks = [];
          this.taskList.forEach(task => {

            if (!task.taskNumber) {
              return;
            }

            const roleColor = '#' + Math.floor(Math.random() * 16777215).toString(16);

            if (task.user == null) {
              task.user = this.activeUsers.find(f => f.userRoles.some(a => a.roleName === 'Planner Portal Administrator'));
            }

            newUsers.push({
              'name': task.user.name + ' ' + task.user.surname,
              'role': task.user.userRoles[0].roleName,
              'roleInitial': task.user.userRoles[0].roleName.substring(0, 1),
              'roleColor': roleColor
            });
            newTasks.push({
              'number': task.taskNumber.number,
              'task': task.taskNumber.name,
              'user': task.user.name + ' ' + task.user.surname,
              'notes': task.comment ?? '',
              'status': task.taskStatus.value
            });
            this.users = newUsers;
            this.tasks = newTasks;
            this.setPhase();
          });
        });
        return;
      }
      else {
        this.taskList = result;
        this.taskList = this.taskList.sort((a, b) => {
          const numA = a.taskNumber?.number ?? 9999;
          const numB = b.taskNumber?.number ?? 9999;
          return numA - numB;
        });
        let newUsers = [];
        let newTasks = [];
        this.taskList.forEach(task => {
          if (!task.taskNumber) {
            return;
          }
          const roleColor = '#' + Math.floor(Math.random() * 16777215).toString(16);

          if (task.user == null) {
            task.user = this.activeUsers.find(f => f.userRoles.some(a => a.roleName === 'Planner Portal Administrator'));
          }

          newUsers.push({
            'name': task.user.name + ' ' + task.user.surname,
            'role': task.user.userRoles[0].roleName,
            'roleInitial': task.user.userRoles[0].roleName.substring(0, 1),
            'roleColor': roleColor
          });
          newTasks.push({
            'number': task.taskNumber.number,
            'task': task.taskNumber.name,
            'user': task.user.name + ' ' + task.user.surname,
            'notes': task.comment ?? '',
            'status': task.taskStatus.value
          });
          this.users = newUsers;
          this.tasks = newTasks;
          this.setPhase();
        });
      }
    });
  }

  getUsers(): void {
    this.userService.apiV1UserManagementGetUsersGet().subscribe(user => {
      this.activeUsers = user;
      this.getPropertyListingTasks();
    });
  }

  startEditing(task: any) {
    task.originalUser = task.user;
    task.editing = true;
  }

  goToTaskOverview(taskNumber: number, taskName: string) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        'taskNumber': taskNumber,
        'taskName': taskName,
        'listingType': this.listingType
      }
    };
    this.router.navigate(['admin/listings/task-overview'], navigationExtras);
  }

  onRowClicked(row: any) {
    const isViewOnlyRole = this.currentUserRoles?.some(role =>
      this.requiredRolesView.includes(role)
    );
    if (isViewOnlyRole && row.number === 1) {
      this.goToTaskOverview(row.number, row.task);
      return;
    }

    let correctUserFromTask = this.taskList.find(f => f.taskNumber?.number === row.number).user ?? undefined;

    if ((correctUserFromTask?.id == this.currentUser.id) ||
      (this.activeUsers.find(f => f.userRoles?.some(a => a.roleName === 'Planner Portal Administrator' &&
        f.id == this.currentUser.id))) ||
      (this.hasRequiredRoleFull())) {

      //only go to tasklist if all previous task up to selected are completed
      let taskList = this.taskList;
      let taskIndex = taskList.findIndex(f => f.taskNumber?.number === row.number);
      let previousTasks = taskList.slice(0, taskIndex);
      let previousTasksCompleted = previousTasks.every(f => f.taskStatus?.value === 'Done');

      if (previousTasksCompleted) {
        this.goToTaskOverview(row.number, row.task);
      } else {
        this.notificationService.showWarningMessage('Task Not Available', 'You cannot access this task yet.');
      }

    } else {
      this.notificationService.showWarningMessage('Task Not Available', 'You cannot access this task.');
    }
  }

  getCurrentUser(): void {
    this.userService.apiV1UserManagementGetCurrentUserGet().subscribe(result => {
      if (result != null) {
        this.currentUser = result;
        if (this.currentUser && this.currentUser.userRoles) {
          this.currentUserRoles = []
          for (let index = 0; index < this.currentUser.userRoles.length; index++) {
            const element = this.currentUser.userRoles[index];
            if (element && element.roleName) {
              this.currentUserRoles.push(element.roleName?.toString());
            }
          }
        }
      }
      else {
        this.notificationService.showWarningMessage('No Current User', 'No current user found.');
      }
    });
  }

  compareUsers(u1: UserDto, u2: UserDto): boolean {
    return u1 && u2 ? u1.id === u2.id : u1 === u2;
  }

  async onUserChange(task: any) {
    try {
      const confirmed = await this.notificationService.showConfirmMessage(
        'Confirm User',
        'Are you sure you want to change the user?',
        'Yes',
        'No'
      );

      if (!confirmed) {
        task.editing = false;
        this.getPropertyListingTasks();
        return;
      }
      const realTask = this.taskList.find(t => t.taskNumber?.number === task.number);
      const updatedTask: TaskListDto = {
        id: realTask.id,
        taskNumber: { id: realTask.taskNumber?.id },
        taskStatus: { id: realTask.taskStatus?.id },
        user: { id: task.user?.id }
      };

      this.listingService.apiV1PropertyListingUpdateTaskListPost({
        body: updatedTask
      })
        .subscribe(() => {
          task.editing = false;
          this.notificationService.showSuccessMessage('Updated', 'User updated successfully.');
          this.getPropertyListingTasks();
        });
    } catch (error) {
      console.log('error ' + error); 6
      this.notificationService.showErrorMessage("Error", "Error found in changing user.");
    }
  }

  private getUserPermissionList(): void {
    this._userPermissionService.getRequiredRoles().subscribe(data => {
      this.requiredRolesFull = data.requiredRolesFull;
      this.requiredRolesView = data.requiredRolesView;
    });
  }

  private hasRequiredRoleFull(): boolean {
    return this.currentUserRoles?.some(role => this.requiredRolesFull.includes(role)) ?? false;
  }
}
